<template>
    <section id="payment-types">
        <div class="row">
            <div class="col-sm-12 blackBar"><div class="title">Zahlart wählen</div></div>
        </div>
        <div class="row backgroundGray">
            <div class="col-sm-6">
                <div class="checkbox">
                    <label>
                        <input type="radio" name="payment" value="1" checked>
                        <span><img src="public/images/mastercard_hrz_opt_pos_105_3x.png" height="20px"/> <img src="public/images/Visacard.png" height="20px"/></span>
                    </label>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="checkbox">
                    <label>
                        <input type="radio" name="payment" value="2">
                        <span><img src="public/images/Sofortueberweisung_320x120.png" height="20px"/></span>
                    </label>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="checkbox">
                    <label>
                        <input type="radio" name="payment" value="3">
                        <span><img src="public/images/Paypal_de-pp-logo-200px.png" height="20px"/></span>
                    </label>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  
}
</script>
